export const swatchSizes = {
    xsmall: 12,
    small: 16,
    medium: 20,
    semiLarge: 24,
    large: 28,
};
//# sourceMappingURL=constants.js.map